import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CheckboxStyle } from '../../../../components/styled/global.style'
import { Box, InputAdornment, TextField } from '@mui/material'
import { ContainerModalSetFilter } from './ModalFilter.style'
import Loader from '../../../../components/Loader/Loader'
import SearchIcon from '@mui/icons-material/Search'

const ModalFiltersSet = ({ onModelChange, values, filters, name }) => {
  const [search, setSearch] = useState('')

  const handelSearchChange = event => {
    const { value } = event.target
    setSearch(value)
  }

  const valueChanged = (event, symbol) => {
    const { checked } = event.target
    const element = filters[name] || []
    let copyElements = JSON.parse(JSON.stringify(element))
    if (checked) {
      copyElements.push(symbol)
      onModelChange(copyElements)
    } else {
      const newElements = filters[name].filter(s => s !== symbol)
      onModelChange(newElements)
    }
  }

  return (
    <ContainerModalSetFilter>
      <TextField
        style={{ minWidth: '205px' }}
        className="SearchTextField"
        placeholder="Search"
        autoComplete="off"
        value={search}
        onChange={handelSearchChange}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon className="SearchIcon" />
            </InputAdornment>
          )
        }}
      />
      {Array.isArray(values) ? (
        values
          .filter(v => String(v).toLowerCase().includes(search.toLowerCase()))
          .map(v => (
            <Box key={v} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <CheckboxStyle
                onChange={event => valueChanged(event, v)}
                checked={filters[name]?.includes(v)}
              />
              {v}
            </Box>
          ))
      ) : (
        <Loader></Loader>
      )}
    </ContainerModalSetFilter>
  )
}

export default ModalFiltersSet

ModalFiltersSet.propTypes = {
  onModelChange: PropTypes.func,
  values: PropTypes.array,
  filters: PropTypes.object,
  name: PropTypes.string
}
